module.exports = __webpack_public_path__ + "img/slogan.d42de5b8.png";